import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import PlayButton from "../../assets/icons/play-icon.svg";
import PauseButton from "../../assets/icons/pause-icon.svg";
import VolumeHigh from "../../assets/icons/volume-high.svg";
import VolumeMute from "../../assets/icons/volume-mute.svg";

function VideoPlayer({
  description = null,
  primaryTitle = null,
  URL = "",
  poster,
  className = "gradient-from-bottom-50",
  wrapperClassName = "",
  videSource = "",
  muted = false,
  ...rest
}) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isControlsVisible, setIsControlsVisible] = useState(false);
  const [isMute, setIsMute] = useState(muted);

  const videoRef = useRef(null);

  const videoHandler = (control) => {
    setIsPlaying(control === "play");

    if (control === "play") {
      videoRef.current.play();
    } else if (control === "pause") {
      videoRef.current.pause();
    }
  };

  const showControls = () => setIsControlsVisible(true);
  const hideControls = () => setIsControlsVisible(false);

  const volumeHandler = (control) => {
    setIsMute(control === "mute");

    if (control === "mute") {
      videoRef.current.muted = true;
    } else if (control === "unmute") {
      videoRef.current.muted = false;
    }
  };

  return (
    <div
      className={clsx("relative overflow-hidden", wrapperClassName)}
      onMouseEnter={showControls}
      onMouseLeave={hideControls}
    >
      <div className="relative h-max flex items-center justify-center">
        <video ref={videoRef} className="w-full outline-none" loop poster={poster}>
          <track kind="captions" />
          <source src={videSource} type="video/mp4" />
        </video>
        {!isPlaying && (
          <button onClick={() => videoHandler("play")} type="button" className="absolute z-10">
            <img className="w-[24px] sm:w-[50px]" src={PlayButton} alt="" />
          </button>
        )}
        {isPlaying && isControlsVisible && (
          <button onClick={() => videoHandler("pause")} type="button" className="absolute z-10">
            <img className="w-[24px] sm:w-[50px]" src={PauseButton} alt="" />
          </button>
        )}

        {isControlsVisible && (
          <button
            onClick={() => volumeHandler(isMute ? "unmute" : "mute")}
            type="button"
            className="absolute left-8 top-3 md:top-5 z-10"
          >
            <img className="w-[20px] md:w-[30px]" src={isMute ? VolumeMute : VolumeHigh} alt="" />
          </button>
        )}
      </div>

      <div
        className={clsx(
          "w-full h-full flex items-end bg-bottom bg-no-repeat bg-cover px-[20px] lg:px-[24px] xl:px-[40px] py-4 md:py-0 md:absolute bottom-0 text-center lg:text-start",
          className,
        )}
        {...rest}
      >
        <div>
          <span className="text-24px font-bold uppercase">{primaryTitle}</span>
          <p className="mb-[0 mt-[12px] max-w-[800px]">{description}</p>
        </div>
      </div>
    </div>
  );
}

export default VideoPlayer;

VideoPlayer.propTypes = {
  description: PropTypes.string,
  URL: PropTypes.string,
  poster: PropTypes.string,
  minHeight: PropTypes.number,
};
